import React from 'react';

const Soccer = () => {
  const cards = [
    {
      image: "https://images.unsplash.com/photo-1522778119026-d647f0596c20?auto=format&fit=crop&w=900&q=80",
      tag: "UEFA Nights",
      title: "European Under the Lights",
      description: "Midweek drama from the biggest clubs in the world.",
      link: "https://www.dazn.com/en-IN/welcome/en-IN/welcome",
      linkText: "See Partner Coverage →"
    },
    {
      image: "https://images.unsplash.com/photo-1579952363873-27f3bade9f55?auto=format&fit=crop&w=900&q=80",
      tag: "Women's Football",
      title: "Elite Women's Leagues",
      description: "Follow top women's divisions and cup competitions from Europe and beyond.",
      link: "https://www.dazn.com/en-IN/welcome/en-IN/welcome",
      linkText: "Explore Matches →"
    },
    {
      image: "https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?auto=format&fit=crop&w=900&q=80",
      tag: "Global Game",
      title: "Weekend Round-Up",
      description: "Results, storylines and standout moments from across the football world.",
      link: "https://www.dazn.com/en-IN/welcome/en-IN/welcome",
      linkText: "Read Round-Up →"
    }
  ];

  return (
    <section className="section" id="uefa">
      <div className="section-title">Soccer & Women's Football</div>
      <div className="section-sub">International club nights, UEFA competitions and elite women's football are followed closely in our coverage, with some matches available via selected streaming partners.</div>

      <div className="grid-3">
        {cards.map((card, index) => (
          <div key={index} className="card">
            <img src={card.image} alt={card.tag} />
            <div className="card-body">
              <div className="card-tag">{card.tag}</div>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
              <a href={card.link}>{card.linkText}</a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Soccer;
